import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Mail } from "lucide-react";
import API from "../api/axiosConfig";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No se encontró el token de verificación.");
      return;
    }

    API.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus("success"))
      .catch((err) => {
        setStatus("error");
        setMessage(
          err.response?.data?.message ||
          "El enlace es inválido o ya expiró. Solicita uno nuevo desde tu perfil."
        );
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md text-center">

        {status === "loading" && (
          <>
            <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-4">
              <Loader2 size={32} className="text-blue-500 animate-spin" />
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">Verificando tu correo...</h1>
            <p className="text-sm text-gray-500">Por favor espera un momento.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 size={36} className="text-green-500" />
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">¡Correo verificado!</h1>
            <p className="text-sm text-gray-500 mb-6">
              Tu dirección de correo electrónico ha sido confirmada exitosamente. Ya puedes disfrutar de todos los beneficios de Qkiere.
            </p>
            <button
              onClick={() => navigate("/")}
              className="w-full py-3 rounded-xl bg-supernova-400 hover:bg-supernova-500 text-black font-bold transition"
            >
              Ir al inicio
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle size={36} className="text-red-500" />
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">No se pudo verificar</h1>
            <p className="text-sm text-gray-500 mb-6">{message}</p>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate("/myprofile")}
                className="w-full py-3 rounded-xl bg-blue-500 hover:bg-blue-600 text-white font-bold transition flex items-center justify-center gap-2"
              >
                <Mail size={16} /> Reenviar correo desde mi perfil
              </button>
              <button
                onClick={() => navigate("/")}
                className="w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold hover:bg-gray-50 transition"
              >
                Volver al inicio
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
